export default __webpack_public_path__ + "static/media/purple-heart.cf1a5ee2.svg";